import React from "react";
import StatsBlock from "./stats-block.jsx";

class TicketsAtAGlance extends React.Component {
  render() {
    return (
      <StatsBlock
        value={this.props.event.quantity_sold}
        subvalue={this.props.event.unlimited ? "∞" : this.props.event.quantity}
        label="Tickets issued"
      />
    );
  }
}

export default TicketsAtAGlance;



// WEBPACK FOOTER //
// ./src/app/components/partials/tickets-at-a-glance.jsx